// AppUpdateEvery - HOW OFTEN THE ARCHIVE IS UPDATED, IN ONE PLACE (audit 2026-10-12).
//
// The service rebuilds each subscriber's folder on its refresh cycle (`BridgeEnv.DefaultRefreshSeconds`). Nine
// sentences in the app told the subscriber "within about 15 minutes", each with the number typed in by hand; only the
// sign-up's done card was held to the service's own number. A sentence that names a time is a promise, so every one
// of them reads the number here, and `SignUpPromise.test.ts` (Bridge) holds it equal to the service's interval.
//
// ⛔ THIS IS THE SERVICE'S INTERVAL, NOT A FORECAST OF A WAIT. A new sentence that needs it uses `Within` /
// `AtMost`; `Bridge/src/tests/SignUpPromise.test.ts` fails on a "15 minutes" typed anywhere else in `App/src`.
//
// Habitat-free (no DOM, no transport, no imports): anything may import it, the Bridge's tests included.

export class AppUpdateEvery {
    /** The service's refresh interval in seconds. ⛔ Pinned to `BridgeEnv.DefaultRefreshSeconds` by a Bridge test. */
    public static readonly Seconds: number = 30;

    /** The interval plus the cycle's own work, in words (30 s cycle -> "a minute"). ⚠ After `Seconds` (static order). */
    public static readonly Span: string = AppUpdateEvery.Seconds <= 30 ? "a minute" : String(Math.ceil(AppUpdateEvery.Seconds / 60) + 1) + " minutes";

    /** "within about a minute" - when something made by the next update will be there. */
    public static readonly Within: string = "within about " + AppUpdateEvery.Span;

    /** "at most about a minute" - how old the newest thing in the archive can be. */
    public static readonly AtMost: string = "at most about " + AppUpdateEvery.Span;

    /** "up to about a minute" - how long the first archive takes. */
    public static readonly UpTo: string = "up to about " + AppUpdateEvery.Span;
}
